import { ReactNode, useState } from 'react';
import AuthContext from './AuthContext';

export function AuthContextProvider(props: {
  children: ReactNode | ReactNode[];
}) {
  const [authUser, setAuthUser] = useState<any>();
  const clearAuthUser = () => setAuthUser(undefined);
  return (
    <AuthContext.Provider
      value={{
        authUser,
        setAuthUser,
        clearAuthUser,
        authUserLoading: false,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}
